import { create } from 'zustand';

const useAuthStore = create((set, get) => ({
  user: null,
  isAuthenticated: false,
  isLoading: true,
  error: null,

  setUser: (user) => set({ 
    user, 
    isAuthenticated: !!user,
    isLoading: false,
    error: null 
  }),

  clearUser: () => set({ 
    user: null, 
    isAuthenticated: false,
    isLoading: false,
    error: null 
  }),

  setError: (error) => set({ 
    error,
    isLoading: false 
  }),

  setLoading: (isLoading) => set({ isLoading }),

  // Function to trigger subscription refresh (can be called from anywhere)
  refreshSubscription: () => {
    // This will be used by components to trigger subscription refresh
    // The actual implementation is in the useRefreshSubscription hook
    return true;
  },
}));

export default useAuthStore;